import * as React from "react";
import Icon from "components/common/Icon";
const StatusIcon = ({ active, className = void 0 }, ref) => /* @__PURE__ */ React.createElement(
  Icon,
  {
    ref,
    name: active ? "check_circle" : "cancel",
    bsStyle: active ? "success" : void 0,
    className,
    title: active ? "Yes" : "No"
  }
);
export default React.forwardRef(StatusIcon);
